module.exports = __webpack_public_path__ + "static/img/10.0729b38.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/sp/10.png
// module id = GG4v
// module chunks = 0